import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonResponsiveWrapper, costFormater, Preloader, useResponsive } from '@common-fe/common-fe';
import _ from 'lodash';

import AppButton from '@/components/controls/AppButton';
import { PendingModal } from '@/components/elements';

const BUTTON_WIDTH = '130px';

interface Props {
  visible: boolean;
  fundingAmount: string;
  onSetVisible: (value: boolean) => void;
  onSubmit: () => void;
  isLoading: boolean;
}
const ConfirmBuyModal: React.FC<Props> = ({ visible, fundingAmount, onSetVisible, onSubmit, isLoading }) => {
  const { t } = useTranslation();
  const { isMobile } = useResponsive();

  const handleSubmit = useCallback(() => {
    if (isLoading) {
      return;
    }
    onSubmit();
  }, [isLoading, onSubmit]);
  return (
    <PendingModal
      testId="confirm-buy-modal"
      header={`${t('Move ')} ${costFormater(_.toNumber(fundingAmount), true)} ${t(
        'into your investment account?'
      )}`}
      visible={visible}
      onSetVisible={onSetVisible}
    >
      <ButtonResponsiveWrapper fill={isMobile} margin={{ top: 'spacing12' }}>
        <AppButton
          fill={isMobile}
          testId="confirm-buy-modal_cancel"
          onClick={() => onSetVisible(false)}
          width={BUTTON_WIDTH}
          buttonType="secondary"
        >
          {t('Cancel')}
        </AppButton>

        <AppButton
          fill={isMobile}
          disabled={isLoading}
          testId="confirm-buy-modal_confirm"
          onClick={handleSubmit}
          width={BUTTON_WIDTH}
        >
          {isLoading ? <Preloader testId="confirm-buy-modal_submit-loading" color="white" /> : t('Confirm')}
        </AppButton>
      </ButtonResponsiveWrapper>
    </PendingModal>
  );
};

export default ConfirmBuyModal;
